export default [
  {
    path: "coupons",
    component: () => import(/* webpackChunkName: "CampaignCoupons" */ "@/views/campaigns/details/coupons/Index.vue"),
    meta: {
      bypassCacheKeyCheck: true,
    },
    children: [
      {
        path: "",
        name: "campaign-coupons",
        query: { type: "" },
        component: () => import(/* webpackChunkName: "CampaignCouponsList" */ "@/views/campaigns/details/coupons/List.vue"),
        props: true,
        meta: {
          hasFilters: true,
          title: "campaignCoupons",
          entityName: "campaign-coupons",
          showTabs: true,
          filtersScheme: {
            type: "allocated",
            status: "active",
            advancedFilters: [],
            sortMetrics: "code",
            sortDirection: "asc",
            countries: [],
            trafficSources: [],
            buId: "all",
            team: "",
            nonPerformingCoupons: 0,
            recentAllocations: 0,
          },
        },
      },
      {
        path: "requests",
        component: () => import(/* webpackChunkName: "CampaignCouponsRequests" */ "@/views/campaigns/details/coupons/requests/Index.vue"),
        meta: {
          bypassCacheKeyCheck: true,
          requireAuth: true,
          title: "campaignCouponsRequests",
        },
        children: [
          {
            path: "",
            name: "coupons-requests",
            component: () => import(/* webpackChunkName: "CouponsRequests" */ "@/views/campaigns/details/coupons/requests/List.vue"),
            meta: {
              requireAuth: true,
              title: "campaignCouponsRequests",
              entityName: "campaign-coupons-requests",
              showTabs: false,
              hasFilters: true,
              filtersScheme: {
                status: "pending",
              },
            },
          },

          {
            path: ":requestId",
            redirect: { name: "coupons-request-allocation" },
            component:
              () => import(/* webpackChunkName: "CouponsRequestDetails" */ "@/views/campaigns/details/coupons/requests/details/Index.vue"),
            meta: {
              bypassCacheKeyCheck: true,
              requireAuth: true,
              showTabs: false,
            },
            children: [
              {
                path: "allocate",
                name: "coupons-request-allocation",
                component:
                  () => import(/* webpackChunkName: "CouponsRequestAllocation" */
                    "@/views/campaigns/details/coupons/requests/details/Allocation.vue"
                  ),
                meta: {
                  bypassCacheKeyCheck: true,
                  requireAuth: true,
                  title: "campaignCouponsRequestsAllocation",
                  entityName: "campaign-coupons-requests-allocation",
                  showTabs: false,
                },
                props: true,
              },
            ],

          },
        ],
      },

      {
        path: "allocation",
        name: "coupons-allocation",
        component: () => import(/* webpackChunkName: "CouponsAllocation" */ "@/views/campaigns/details/coupons/Allocation.vue"),
        props: true,
        meta: {
          bypassCacheKeyCheck: true,
          requireAuth: true,
          title: "campaignCouponsAllocation",
          entityName: "campaign-coupons-allocation",
          showTabs: false,
        },
      },
      {
        path: "add-missing",
        name: "add-missing",
        component: () => import(/* webpackChunkName: "AddMissing" */ "@/views/campaigns/details/coupons/AddMissing.vue"),
        props: true,
        meta: {
          bypassCacheKeyCheck: true,
          requireAuth: true,
          title: "addMissingCoupons",
          entityName: "add-missing-coupons",
          showTabs: false,
        },
      },
      {
        path: "upload",
        name: "upload",
        component: () => import(/* webpackChunkName: "CouponsUpload" */ "@/views/campaigns/details/coupons/Upload.vue"),
        meta: {
          bypassCacheKeyCheck: true,
          requireAuth: true,
          title: "campaignCouponsUpload",
          entityName: "campaign-coupons-upload",
          showTabs: false,
        },
      },

      {
        path: ":couponId",
        component: () => import(/* webpackChunkName: "CouponDetails" */ "@/views/campaigns/details/coupons/Details.vue"),
        name: "coupon-details",
        meta: {
          bypassCacheKeyCheck: true,
          requireAuth: true,
          title: "campaignCouponDetails",
          entityName: "campaign-coupon-details",
          showTabs: false,
        },
      },
    ],
  },
]
